"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chainedRequest = _interopRequireDefault(require("../../util/chainedRequest"));

var _mobx = require("mobx");

var _extend = _interopRequireDefault(require("lodash/extend"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// Usage:
// options.errorMessage (string) - the default handler will use this error message in the flash notification to the user
//                                 if no form error is provided by the server
// options.errorHandler (func)   - the default handler will surface the form error generated by the server, if one was provided. Otherwise,
//                                 the options.errorMessage will be shown. options.errorHandler should be a function which accept (err, res)
//                                 as parameters. If you supply options.errorHandler, any value supplied for options.errorMessage will be discarded.
// options.disableLoadSpinner (bool) - disables the loading spinner for the request
var ApiGetter = /*#__PURE__*/function () {
  function ApiGetter(dispatcher, options) {
    var _this = this;

    _classCallCheck(this, ApiGetter);

    this.dispatcher = dispatcher;
    this.settings = {
      errorMessage: "Oops! There was a problem getting data from the server",
      errorHandler: function errorHandler(err, res) {
        var errorMessage = (0, _get.default)(res, ["body", "errors", "form-level-error", 0, "errorMessageText"], _this.errorMessage);

        _this.dispatcher.emit("SHOW_FLASH_MESSAGE", {
          message: errorMessage,
          className: "warning"
        });
      }
    };
    this.settings = (0, _extend.default)({}, this.settings, options);
  }

  _createClass(ApiGetter, [{
    key: "createRequest",
    value: function createRequest() {
      var req = (0, _chainedRequest.default)(this.dispatcher);

      if (!this.settings.disableLoadSpinner) {
        req = req.withLoadSpinner();
      }

      return req;
    }
  }, {
    key: "fetch",
    value: function fetch(endpoint, callback, errorHandler, queryParameters) {
      var req = this.createRequest();
      req.get(endpoint).query(queryParameters).respond().onError((0, _isNull.default)(errorHandler) ? this.settings.errorHandler : errorHandler).handle((0, _mobx.action)(function (err, res) {
        callback(res.body.result);
      }));
    }
  }, {
    key: "fetchSearchResults",
    value: function fetchSearchResults(endpoint, callback, errorHandler) {
      var req = this.createRequest();
      req.get(endpoint).respond().onError((0, _isNull.default)(errorHandler) ? this.settings.errorHandler : errorHandler).handle((0, _mobx.action)(function (err, res) {
        callback(res);
      }));
    }
  }, {
    key: "del",
    value: function del(endpoint, callback, errorHandler, pathParameters) {
      var req = this.createRequest();
      req.del(endpoint).send(pathParameters).respond().onError((0, _isNull.default)(errorHandler) ? this.settings.errorHandler : errorHandler).handle((0, _mobx.action)(function (err, res) {
        callback(res.body.result);
      }));
    }
  }, {
    key: "post",
    value: function post(endpoint, callback, errorHandler, pathParameters, queryParameters) {
      var req = this.createRequest();
      req.post(endpoint).query(queryParameters).send(pathParameters).respond().onRedirect().onError((0, _isNull.default)(errorHandler) ? this.settings.errorHandler : errorHandler).handle((0, _mobx.action)(function (err, res) {
        callback(res.body.result);
      }));
    }
  }, {
    key: "postWithCredentials",
    value: function postWithCredentials(endpoint, callback, errorHandler, pathParameters) {
      var req = this.createRequest();
      req.post(endpoint).withCredentials().send(pathParameters).respond().onError((0, _isNull.default)(errorHandler) ? this.settings.errorHandler : errorHandler).onRedirect().handle((0, _mobx.action)(function (err, res) {
        callback(res.body.result);
      }));
    } // Do not mix postWithAttachment and send(...)

  }, {
    key: "postWithAttachment",
    value: function postWithAttachment(endpoint, callback, attachment, errorHandler) {
      var req = this.createRequest();
      req.postWithAttachment(endpoint, attachment).respond().onError((0, _isNull.default)(errorHandler) ? this.settings.errorHandler : errorHandler).handle((0, _mobx.action)(function (err, res) {
        callback(res.body.result);
      }));
    }
  }]);

  return ApiGetter;
}();

var _default = ApiGetter;
exports.default = _default;